export default "__VITE_ASSET__DxyeHR2A__"